/** Merge a mutation response into the selected paper. Mutation responses
 * carry angle_scores/highlight_count/tags as null or defaults (1c-1 contract),
 * so copy named fields only — never replace the object. */
import type { PaperWithRole } from "@/types/paper";

export function mergeScoreOverride(cur: PaperWithRole | null, updated: PaperWithRole): PaperWithRole | null {
  if (!cur || cur.id !== updated.id) return cur;
  return { ...cur, user_score_override: updated.user_score_override, override_timestamp: updated.override_timestamp };
}
